import { useQuery } from '@tanstack/react-query';
import qs from 'query-string';

import CategoryApi from '../../../lib/api/category/CategoryApi';
import { CATEGORY } from '../../../constants/queryKeys';

/**
 * 카테고리 상품 리스트 엑셀 다운로드 응답 데이터 타입
 * @typedef categoryProductExcelDownloadResponseDataType
 * @property {string} adminEmail - 다운로드 한 카테고리 상품 리스트 엑셀 파일을 받을 이메일
 */

/**
 * 검색한 카테고리 상품 리스트 엑셀 다운로드를 요청하는 query hook
 * @param {number} categoryId - 카테고리 ID
 * @param {object} filterOption - 카테고리 상품 검색 필터
 * @param {string} [filterOption.storeName] - 브랜드 명
 * @param {string} [filterOption.storeId] - 브랜드 ID
 * @param {string} [filterOption.storeStatus] - 브랜드 상태
 * @param {string} [filterOption.id] - 상품 ID
 * @param {string} [filterOption.name] - 상품 명
 * @param {string} [filterOption.status] - 판매 상태
 * @param options - react-query options 객체
 * @return {UseQueryResult<AxiosPromise<categoryProductExcelDownloadResponseDataType>, AxiosError>}
 */
const useCategoryProductExcelDownload = (categoryId, filterOption, options) => {
  const queryString = `?${qs.stringify(filterOption, { skipNull: true })}`;

  return useQuery(
    [...CATEGORY.PRODUCT_LIST_EXCEL, queryString],
    () => CategoryApi.getCategoryProductExcelDownload(`${queryString}&categoryId=${categoryId}`),
    options,
  );
};
export default useCategoryProductExcelDownload;
